<template>
  <v-layout row justify-center>
    <v-dialog v-model="isOpen" persistent width="400px">
      <v-card class="common-dialog">
        <v-card-title class="text-h5 font-weight-bold">
          <div>
            {{ headerText }}
          </div>
        </v-card-title>
        <v-divider class="ml-3 mr-3" />
        <v-card-text class="body">
          <slot name="body" />
        </v-card-text>
        <v-divider class="mt-2 ml-3 mr-3" />
        <v-card-actions class="btn-group">
          <v-btn class="text-decoration-underline" text primary depressed @click="emitCancel">
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn :disabled="okBtnDisabled" class="ok-btn" @click="emitOk">
            {{ okBtnText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    headerText: {
      type: String,
      required: true,
    },
    okBtnText: {
      type: String,
      default() {
        return this.$t('actions.ok');
      },
    },
    okBtnDisabled: {
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    emitOk() {
      this.$emit('onOk');
    },

    emitCancel() {
      this.$emit('onCancel');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
::v-deep {
  .v-dialog {
    border-radius: 0;
  }

  .v-input--radio-group {
    .v-item--active {
      .v-label {
        color: $common-dialog-radio-active-color;
      }
    }

    .v-label {
      font-size: 1.2rem;
    }
  }
}

.v-card {
  &.common-dialog {
    background-color: $common-dialog-bg-color;
    border-left: 6px solid $common-dialog-border-color;
    border-radius: 0;

    .v-card__title {
      color: $common-dialog-header-color;
    }
  }

  .body.v-card__text {
    font-size: 1.4rem;
    color: $common-dialog-text-color;
    padding-bottom: 0;
    max-height: 60vh;
    overflow-y: auto;
  }

  .btn-group.v-card__actions {
    justify-content: end;
    padding: 1rem 3rem 2rem;

    .ok-btn {
      color: $pricing-white;
      background-color: $btn-ok-color;
      border-color: $btn-ok-color;
      letter-spacing: normal;
    }
  }
}

.v-btn {
  font-size: 1.2rem;
  letter-spacing: normal;
}
</style>
